export const saveLessonsToLocalStorage = (lessons, key) => {
  if (typeof window !== "undefined") {
    window.localStorage.setItem(key, JSON.stringify(lessons));
    window.localStorage.setItem(
      `savingTimeOf${capitalizeFirstLetter(key)}`,
      Date.now().toString(),
    );
  }
};

export const getLessonsFromLocalStorage = (key) => {
  if (typeof window !== "undefined") {
    return JSON.parse(window.localStorage.getItem(key) as string);
  }
  return null;
};

export const isOneHourLate = (key) => {
  if (typeof window !== "undefined") {
    const savingTime = Number(
      window.localStorage.getItem(`savingTimeOf${capitalizeFirstLetter(key)}`),
    );
    const now = Date.now();

    return Math.abs(now - savingTime) / 36e5 >= 1;
  }
  return null;
};

const capitalizeFirstLetter = (string) =>
  `${string.charAt(0).toUpperCase()}${string.slice(1)}`;
